module.exports = __webpack_public_path__ + "img/Weapon_296.8048fa3b.png";